import { createContext, useContext, useState } from "react"
import { assetService } from "../services/assetService"
const AssetContext = createContext({})

export const useAssetContext = () =>  useContext(AssetContext)

export const AssetContextProvider = ({ children }) => {
    const [assets, setAssets] = useState([])
    const [loadingAssets, setLoadingAssets] = useState(false)
    const getAssets = async (params) => {
        try {
            setLoadingAssets(true)
            const response = await assetService.getAssets(params)
            setAssets(response.data)
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingAssets(false)
        }
    }

    
    return (
        <AssetContext.Provider value={{ assets, setAssets, loadingAssets, getAssets }}>
            {children}
        </AssetContext.Provider>
    )
}